import { definitions } from "../../common-fetch/generated/orders-model-api";
import { atom } from "../../common/miscellaneous/atom";
import { RecoilKeys } from "../../common/miscellaneous/RecoilKeys";

export type Country = definitions["Country"] & {
  readonly translationKey?: string;
};

export type Countries = ReadonlyArray<Country>;

export type CountriesState = Countries | "initializing";

export const countriesAtom = atom<CountriesState>({
  key: RecoilKeys.Countries,
  default: "initializing",
});
